module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-6.1c22fa8b.jpg";